document.addEventListener('click', function (e) {
  var t = e.target.closest('.thumbs img');
  if (t) {
    var main = t.closest('.pdp__gal').querySelector('.pdp__main img');
    if (main) { main.src = t.dataset.src; main.srcset = ''; }
    t.parentNode.querySelectorAll('img').forEach(function (i) { i.classList.remove('is-active'); });
    t.classList.add('is-active');
  }
  var b = e.target.closest('.menu-toggle');
  if (b) {
    var open = document.body.classList.toggle('menu-open');
    b.setAttribute('aria-expanded', open ? 'true' : 'false');
  }
  if (e.target.closest('.nav a')) { document.body.classList.remove('menu-open'); }
  // Close the country selector dropdown when clicking outside of it
  document.querySelectorAll('details.hd-loc[open]').forEach(function (d) {
    if (!d.contains(e.target)) { d.removeAttribute('open'); }
  });
});

document.addEventListener('change', function (e) {
  var s = e.target.closest('#SortBy');
  if (s) { window.location.href = s.dataset.base + '?sort_by=' + s.value; }
});
